// extracted by mini-css-extract-plugin
export default {"pool":"RobotLoader_pool__JLJEW","shake":"RobotLoader_shake__O3xjS"};